<template>
	<div class="overalls">
<!-- 
		<div class="instatefiter">
			<div class="filter">搜索：<input type="text" v-model="searchQuery" class="inputfilter"> </div>
			<div class="state" style="display: flex;align-items: center;">
				产品状态：<select v-model="stateQuery" class="statefilter" name="" id="" style="font-size: 14px;">
					<option value="">全部</option>
					<option value="进行中">进行中</option>
					<option value="已完成">已完成</option>
				</select>
			</div>
		</div> -->


		<!-- 产品名称 -->
		<div class="state-main">
			<div class="pad-main" v-for="item in content" :key="`${item.proname}_${item.startTime}`">
				<div class="sprint-left">
					<div class="sprint-mian">
						<div class="sprint-colors" style="width: 320px; margin-left: 25px; display: flex;align-items: center;">
							<div class="pad-state"><div class="colors-state" :style="{background:state(item.states)}"></div></div>  <div style="margin-left: 7px;font-size: 12px;color: #938d8d;"> 产品名称：</div>
							<div style="font-size: 20px;margin: 7px;color:#938d8d;">
							{{ item.proname }}
						</div>
						</div>
					</div>


<!-- 					负责团队 -->
					<div class="sprint-mian" style="margin-top: -15px;" >
						<div class="sprint-colors" >
							负责团队：<div style="font-size: 16px;color: #938d8d;">
							{{ item.teamname }}</div>
						</div>


<!-- 开始时间 -->
					<div class="sprint-gotime">
						<div class="sprint-colors" style="margin-top: 10px;">
							开始时间：<div style="color: #938d8d;font-size: 17px;"> {{ item.startTime }}</div> 
						</div>

					</div>


					<!-- 结束时间 -->
					<div class="sprint-endTime">
						<div class="sprint-colors" style="margin-top: 10px;">
							结束时间：<div style="color: #938d8d;font-size: 17px;"> {{ item.endTime }}</div>
						</div>
					</div>




					</div>

				</div>


				<div class="sprint-right">
	
					<!-- <el-progress class="sprint-working" :text-inside="true" :stroke-width="24"  :percentage="item.realgs" status="exception">
						<div class="sprint-colors">
							消耗工时：
						</div>
						{{ item.realgs + "h" }}
					</el-progress> -->


					<!-- 消耗工时 -->
					<div class="sprint-working">
						<div class="sprint-colors">
						 <div style="color: #938d8d;">{{ item.realgs + "h" }}</div>	
						</div>
					</div>
					<!-- 状态 -->
					<div class="sprint-state"  style="width: 155px;height: 30px;margin-left: 1px;"
						> <div style="color:#dfd7d7db ;">state：</div> <div :style="{ color: stateWriking(item.states) }" > {{ item.states }}</div>
					</div>
					<!-- <div class="sprint-mian" ></div> -->

				</div>
				<div class="sprint-mainwk">


				</div>
				<!-- 进度条 -->
					<div class="sprint-bom">
						<el-progress class="sprint-wrking"   :color="getProgressColor" type="line"
						:text-inside="true"
						:stroke-width="20"
						:percentage="Number(item.sadvance?item.sadvance.toFixed(1):0)">进度：
						</el-progress>


					</div>

			</div>
		</div>
	</div>
</template>

<script>
 
import api from '@/api/global/sprintGlobal.js';
import { color } from 'echarts';

export default {
	data() {
		return {

			//初始化数据，用数组接收
			content: [],
			// 初始化筛选产品名置空，
			searchQuery: "",
			dataLoaded: false,
			stateQuery: "",

		}

	},
	methods: {

		//进度条颜色
		getProgressColor(percentage) {
			const num = parseFloat(percentage)
			if (num < 25) return '#f56c6c'
			if (num < 50) return '#e6a23c';  // 紫色
			if (num < 75) return '#aa96da';  // 绿色
			if (num >= 100) return '#1debe8';  // 蓝色
			return '#67c23a';  // 绿色
			//  67c23a 这是绿色 
			// aa96da 这是紫色
			// 1debe8 这是蓝色 
			// e6a23c 这是黄色

		},


		//  更改 小圆点的颜色
		state(state) {

			const colorMap = {
				"进行中": "brown",
				"已完成": "#67c23a",
			}
			return colorMap[state] || "";
			
		},
		// 状态值的颜色,
		stateWriking(states){
			const colorMap = {
				"进行中": "#e6a23c",
				"已完成": "#67c23a",
			}
			return  colorMap[states] || "";
			}


		// 获取数据
		// fetchData() {
		// 	this.axios.post(uri.serverUrl + '/getsprint/sprintlist', {
		// 		headers: { 'Content-Type': 'application/json' }
		// 	})
		// 		.then(response => {
		// 			this.content = response.data?.length ? response.data : [];
		// 			this.dataLoaded = true
		// 		})
		// 		.catch(error => {
		// 			console.error('API error:', error)
		// 		})
		// }

	},

	// 获取列表接口
	created() {
		api.fetchData({},res=>{
			this.content = res.data?.length ? res.data : [];
		},err=>{})

	},
	computed: {
		
		// filteredData() {
		// 	return this.content.filter(item => {
		// 		// 产品名称筛选
		// 		const nameMatch = String(item.proname || '')
		// 			.toLowerCase()
		// 			.includes(String(this.searchQuery).toLowerCase())

		// 		// 状态筛选
		// 		const stateMatch = !this.stateQuery ||
		// 			String(item.states || '').toLowerCase() === String(this.stateQuery).toLowerCase()
		// 		return nameMatch && stateMatch
		// 	})

		// },

	}
}
</script>

<style scoped>
.overalls {
	height: 74vh;
	width: 80vw;
	border: 2px solid #dedad9;
	/* background-color: #e6a23c; */
}

.overalls .instatefiter {
	display: flex;
	align-items: center;
	justify-content: space-around;
}

.overalls .instatefiter .state {
	/* margin-left: 150px; */
}

/* 状态筛选 */
.overalls .instatefiter .statefilter {
	height: 30px;
	width: 100px;
	outline: none;
}

/* 产品筛选 */
.overalls .filter {

	height: 70px;
	display: flex;
	align-items: center;
	/* margin-left: 20px; */
	/* background-color: #43e64063; */

}

/* 搜索框筛选 */

/* 
.overalls .filter .inputfilter {
	height: 30px;
	width: 190px;
	outline: none;

}
*/
.state-main {
	height: 100%;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;


}

.pad-main .sprint-left .sprint-mian {
	/* margin-top: 7px; */
	padding: 10px 30px;
	font-size: 14px;
}



.pad-main .sprint-colors {
	color: #dfd7d7;
	display: flex;
	width: 270px;
	/* background-color: aquamarine; */
	align-items: center;
	margin-left: 30px;

}
.pad-main  .sprint-colors .pad-state {
	height: 11px;
	width: 11px;
	background-color: #dfd7d7;
	display: flex;
	align-items: center;
    justify-content: center;
	border-radius: 60%;

}
.pad-main  .sprint-colors .pad-state .colors-state {
	 height: 6px;
	 width: 6px;
	 border-radius: 60%;
	 
}

.pad-main:hover {}

.pad-main .sprint-left .sprint-mian .sprint-wrking {
	height: 50px;
	/* width: 1px; */
	transition: 2s;
	margin-left: 30px;
	margin-top: 15px;

}

.pad-main {
	height: 190px;
	width: 45%;
	margin: 7px 0 0 30px;
	margin-bottom: 20px;
	border-radius: 10px;
	padding: 10px;
	box-shadow: 5px 5px 5px 5px #ded9d9a7;
	border: 2px solid #459bcc30;
	display: flex;
    align-items: flex-start;
	position: relative;
}
.pad-main:hover{
	box-shadow: 9px 9px 9px 9px #ded9d9a7;
}

.state-main .pad-main .sprint-right {
	height: 100px;
    width: 250px;
	display: flex;
	justify-content: center;
    flex-direction: column;
    align-items: flex-end;
	margin-top: 50px;

}

.sprint-right  .sprint-working {
	height: 35px;
	width: 70%;
	display: flex;
	align-items: center;

}
.sprint-right  .sprint-working .sprint-colors {
    height: 80px;
    width: 80px;
	 border-radius: 80%;
	margin-bottom: 55px;
	margin-left: 40px;
	display: flex;
	justify-content: center;
	border-style: outset;
	box-shadow: inset;
}
.sprint-right  .sprint-working .sprint-colors:hover{
	border-style: inset;
}

.state-main .pad-main .sprint-right .sprint-endTime {
	height: 35px;
	width: 70%;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.state-main .pad-main .sprint-right .sprint-gotime {
	height: 35px;
	width: 70%;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.state-main .pad-main .sprint-right .sprint-state {
	height: 35px;
	width: 70%;
	display: flex;
	align-items: center;
}

.state-main .pad-main .sprint-left {
	height: 100px;
	width: 280px;
	margin-left: -40px;
	/* background-color: aquamarine; */

}

.state-main .pad-main .sprint-left .sprint-mian .sprint-mainwk {
	height: 100px;
	width: 250px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

 .overalls .state-main .pad-main .sprint-bom  {
	height: 20px;
	width: 85%;
	display: flex;
	position: absolute;
	bottom: 8px;
	left: 50px;
 }
 .overalls .state-main .pad-main .sprint-bom .sprint-wrking {
	width: 100%;
 }
 .overalls .state-main .pad-main .sprint-bom  .sprint-wrking .sprint-stat {
	width: 50px;
	height: 20px;
	background-color: aqua;
 }
/* @media (max-width: 500px) {
	.pad-main {
	  width: 100%;
	  height: 40%;
	  margin-left: 5%;
	}
  } */
</style>